import ApiService from './apiService';

/**
 * Service pour gérer les opérations liées aux catégories
 */
class CategoriesService {
    /**
     * Récupérer la liste des catégories avec filtres et pagination
     * @param {Object} params Paramètres de filtrage et pagination
     * @returns {Promise} Réponse de l'API avec la liste des catégories
     */
    getCategories(params = {}) {
        return ApiService.get('/categories', params);
    }

    /**
     * Récupérer l'arborescence des catégories
     * @returns {Promise} Réponse de l'API avec l'arborescence des catégories
     */
    getCategoryTree() {
        return ApiService.get('/categories/tree');
    }

    /**
     * Récupérer une catégorie par son ID
     * @param {Number} id ID de la catégorie
     * @param {Object} params Paramètres additionnels (relations à charger)
     * @returns {Promise} Réponse de l'API avec les détails de la catégorie
     */
    getCategory(id, params = {}) {
        return ApiService.get(`/categories/${id}`, params);
    }

    /**
     * Créer une nouvelle catégorie
     * @param {Object} categoryData Données de la catégorie à créer
     * @returns {Promise} Réponse de l'API avec la catégorie créée
     */
    createCategory(categoryData) {
        return ApiService.post('/categories', categoryData);
    }

    /**
     * Mettre à jour une catégorie existante
     * @param {Number} id ID de la catégorie à mettre à jour
     * @param {Object} categoryData Nouvelles données de la catégorie
     * @returns {Promise} Réponse de l'API avec la catégorie mise à jour
     */
    updateCategory(id, categoryData) {
        return ApiService.put(`/categories/${id}`, categoryData);
    }

    /**
     * Supprimer une catégorie
     * @param {Number} id ID de la catégorie à supprimer
     * @returns {Promise} Réponse de l'API
     */
    deleteCategory(id) {
        return ApiService.delete(`/categories/${id}`);
    }

    /**
     * Récupérer les catégories racines
     * @returns {Promise} Réponse de l'API avec les catégories racines
     */
    getRootCategories() {
        return ApiService.get('/categories', { only_root: true });
    }

    /**
     * Récupérer les sous-catégories d'une catégorie parente
     * @param {Number} parentId ID de la catégorie parente
     * @returns {Promise} Réponse de l'API avec les sous-catégories
     */
    getChildCategories(parentId) {
        return ApiService.get('/categories', { parent_category_id: parentId });
    }

    /**
     * Rechercher des catégories
     * @param {String} query Terme de recherche
     * @param {Object} options Options additionnelles
     * @returns {Promise} Réponse de l'API avec les résultats de recherche
     */
    searchCategories(query, options = {}) {
        return ApiService.get('/categories', {
            search: query,
            ...options
        });
    }
}

export default new CategoriesService();